import React, { useState, useEffect, useContext } from "react";

import StaffTable from "components/staff/StaffTable";
import AdminServices from "services/AdminServices";
import useToggleDrawer from "hooks/useToggleDrawer";
import PageTitle from "components/Typography/PageTitle";
import MainDrawer from "components/drawer/MainDrawer";
import StaffDrawer from "components/drawer/StaffDrawer";
import { SidebarContext } from "context/SidebarContext";
import DataWrapper from "./DataWrapper";
import DeleteModal from "components/modal/DeleteModal";
import useAsync from "hooks/useAsync";
import { FiRefreshCcw } from "react-icons/fi";

import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { FiPlus } from "react-icons/fi";
import sidebar from "routes/sidebar";
import NotFound from "components/table/NotFound";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import socket from "services/SocketService";

// const adminInfo = Cookies.get("adminInfo")
//   ? JSON.parse(Cookies.get("adminInfo"))
//   : null;

const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color: grey;
  padding: 9px 10px;
  margin: unset;
}`;

const Employee = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;

  const { toggleDrawer } = useContext(SidebarContext);
  const [searchText, setSearchText] = useState("");
  const { data, loading, error } = useAsync(() => AdminServices.getAllStaff());
  const { setIsUpdate } = useContext(SidebarContext);
  const [status, setStatus] = useState("");
  const [liveStaff, setLiveStaff] = useState([]);
  const isDataArray = Array.isArray(data?.data);
  const safeData = liveStaff;
  const isAdmin = adminInfo?.id === 1;

  // Keep a mutable copy of the fetched list so the live login-status socket
  // event below can patch a single row without refetching.
  useEffect(() => {
    setLiveStaff(isDataArray ? data.data : []);
    // eslint-disable-next-line
  }, [data]);

  // Live login/logout status — pushed the instant an employee actually
  // logs in/out (see employeeModel.loginEmployee / logoutEmployee).
  useEffect(() => {
    const handleEmployeeStatusUpdate = ({ employee_id, login_status }) => {
      console.log("[employee_status_update] RECEIVED on Staff page:", {
        employee_id,
        login_status,
      });
      if (!employee_id) {
        console.log(
          "[employee_status_update] NOT APPLIED: no employee_id in payload",
        );
        return;
      }
      setLiveStaff((prev) => {
        const matched = prev.some(
          (row) => Number(row.id_employee) === Number(employee_id),
        );
        console.log(
          matched
            ? `[employee_status_update] APPLIED: employee ${employee_id} -> login_status=${login_status}`
            : `[employee_status_update] NOT APPLIED: employee ${employee_id} not found in current list`,
        );
        return prev.map((row) =>
          Number(row.id_employee) === Number(employee_id)
            ? { ...row, login_status }
            : row,
        );
      });
    };

    socket.on("employee_status_update", handleEmployeeStatusUpdate);
    return () =>
      socket.off("employee_status_update", handleEmployeeStatusUpdate);
  }, []);

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "staff" && perm.view === 1,
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "staff" && perm.delete === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "staff" && perm.edit === 1,
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "staff" && perm.add === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "staff" && perm.export === 1,
      );

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const { title, serviceId } = useToggleDrawer();

  const csvData = [
    ["S.No", "First Name", "Last Name", "Email", "Contact", "Staff", "Status"],
    ...(safeData || []).map(
      ({ firstname, lastname, email, mobile, role, status }, index) => [
        index + 1,
        firstname,
        lastname,
        email,
        mobile,
        role,
        status,
      ],
    ),
  ];

  console.log();
  const filteredData =
    safeData?.filter(
      (item) =>
        (item.firstname &&
          item.firstname.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.lastname &&
          item.lastname.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.email &&
          item.email.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.mobile &&
          item.mobile.toString().includes(searchText.toString())) ||
        (item.staff &&
          item.staff.toLowerCase().includes(searchText.toLowerCase())),
    ) || [];

  const handleRefresh = () => {
    setIsUpdate(true);
  };
  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <style>{style}</style>
          <PageTitle sidebar={sidebar().sidebar} />

          <MainDrawer>
            <StaffDrawer id={serviceId} />
          </MainDrawer>

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white !dark:bg-gray-800 mb-5">
            <CardBody>
              <form className="items-center gap-6 flex">
                <div className="flex-1">
                  <Input
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Quick Search"
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Employee
                  </Button>
                )}

                {hideExport && (
                  <ExportDataXlsx
                    title="Staff"
                    exportDataXlsx={csvData}
                    fileNames="Employee List"
                  />
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </form>
            </CardBody>
          </Card>

          <DataWrapper loading={loading} error={error} status={status}>
            {filteredData.length > 0 ? (
              <TableContainer
                className="mb-8"
                style={{
                  maxHeight: "65vh",
                  overflowY: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                    <tr>
                      <TableCell className="text-center">Sl.No.</TableCell>
                      <TableCell className="text-center">Name</TableCell>
                      <TableCell className="text-center">Email</TableCell>
                      <TableCell className="text-center">Contact</TableCell>
                      <TableCell className="text-center">Role</TableCell>
                      <TableCell className="text-center">Status</TableCell>
                      <TableCell className="text-center">Login</TableCell>
                      {(hideEdit || hideDelete) && (
                        <TableCell className="text-center">Actions</TableCell>
                      )}
                    </tr>
                  </TableHeader>

                  <StaffTable
                    staffdata={filteredData}
                    hideEdit={hideEdit}
                    hideDelete={hideDelete}
                  />
                </Table>
              </TableContainer>
            ) : (
              // Show NotFound if there is no data
              <NotFound title="There are no Staffs." />
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default Employee;
